import React, { ReactNode } from 'react';

import './notice-big.scss';

interface NoticeBigProps {
  icon?: string | ReactNode;
  title: string;
  text: React.ReactNode;
  bottom?: React.ReactNode;
  link: React.ReactNode;
}

const NoticeBig: React.FC<NoticeBigProps> = ({
  icon,
  link,
  title,
  text,
  bottom,
}) => (
  <div className="notice-big">
    {icon && typeof icon === 'string' && (
      <div className="notice-big__icon">
        <img src={icon} alt="Notice icon" />
      </div>
    )}
    {icon && typeof icon !== 'string' && (
      <div className="notice-big__icon">{icon}</div>
    )}
    <div className="notice-big__title">{title}</div>
    <div className="notice-big__text">{text}</div>
    {link && (
      <a className="notice-big__download" href="/">
        {link}
      </a>
    )}
    <div className="notice-big__footer">{bottom && bottom}</div>
  </div>
);

export default NoticeBig;
